import { findSkipDay, isDayInCurrentMonth, shouldDisableDate } from "./dateTimeUtils";
import { alpha, useTheme } from "@mui/material";
import { useGetContrastColor } from "../../hooks/useGetContrastColor";
export const useSkipDaysPickerValues = (badgeProps, currentMonth, day, daysForCurrentMonth, mutatingDates) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    const daysInMonth = currentMonth ? currentMonth.days : daysForCurrentMonth;
    const isDisabledDay = (_a = shouldDisableDate(day, daysInMonth)) !== null && _a !== void 0 ? _a : false;
    const isInCurrentMonth = (_b = isDayInCurrentMonth(day, daysInMonth)) !== null && _b !== void 0 ? _b : false;
    const isMutating = (_c = mutatingDates === null || mutatingDates === void 0 ? void 0 : mutatingDates.has(day.utc().format("YYYY-MM-DD"))) !== null && _c !== void 0 ? _c : false;
    const isSkipDay = (_d = findSkipDay(day, daysInMonth)) !== null && _d !== void 0 ? _d : false;
    const targetDay = daysInMonth === null || daysInMonth === void 0 ? void 0 : daysInMonth.find((skipDay) => day.isSame(skipDay.customerDate, "day"));
    const skippedDayColorLight = theme.palette.warning.light;
    const skippedDayBackgroundColor = alpha(skippedDayColorLight, 0.1);
    const selectedTextColor = useGetContrastColor(skippedDayBackgroundColor);
    const skippedDayBorder = `2px solid ${theme.palette.warning.main}`;
    const updatedBadgeProps = Object.assign(Object.assign({}, badgeProps), { invisible: !!isSkipDay || !isInCurrentMonth || isDisabledDay || !!(targetDay && !targetDay.hasMealsAssigned) });
    return {
        isDisabledDay,
        isInCurrentMonth,
        isMutating,
        isSkipDay,
        selectedTextColor,
        skippedDayBackgroundColor,
        skippedDayBorder,
        targetDay,
        updatedBadgeProps,
    };
};
